
import './App.css';
import router from './utils/routes';
import { RouterProvider } from 'react-router-dom';
import { UserContext } from './context/userAuth';
import { useContext, useEffect } from 'react';
import CartContextProvider from './context/CartContext';
import { Toaster } from 'react-hot-toast';
function App() {

  const { setUserToken } = useContext(UserContext);
  useEffect(() => {
    try {
      const token = localStorage.getItem('userToken');
      if (token) {
        setUserToken(token)
      } else {
        setUserToken(null);
      }
    } catch {
      alert('Something Went Wrong!');
    }
  }, [])
  return (
    <CartContextProvider>
      <RouterProvider router={router} />
      <Toaster />
    </CartContextProvider>

  )
}

export default App;
